import { CustomModalLayout, Loader, Modal } from "@wix/design-system";
import React from "react";

const ApiKeyChangeModal = (props: any) => {
  return (
    <Modal
      isOpen={props?.showChangeApiKeyConfirmation}
      onRequestClose={() => props?.setShowChangeApiKeyConfirmation(false)}
      shouldCloseOnOverlayClick
      screen="desktop"
    >
      <CustomModalLayout
        primaryButtonText={props?.isReplacing ? <Loader size="tiny" /> : "Confirm"}
        primaryButtonOnClick={props?.replaceApiKey}
        secondaryButtonText="Cancel"
        secondaryButtonOnClick={() => props?.setShowChangeApiKeyConfirmation(false)}
        onCloseButtonClick={() => props?.setShowChangeApiKeyConfirmation(false)}
        title="New Api Key Detected"
        subtitle="Adding the new API key will Automatically remove Previous data and Sync New data"
        overflowY="none"
      />
    </Modal>
  );
};

export default ApiKeyChangeModal;
